import AbstractView from 'abstracts/AbstractView';
import Device from 'controllers/Device';

export default class TransitionAwards extends AbstractView {
	
	
	constructor( $wrapper ) {
		super();
		this.$wrapper = $wrapper;
		this.init();
	}
	
	
	initDOM() {
		let maxLines;
		if ( !Device.IS_TOUCH ) {
			maxLines = 11
		} else {
			maxLines = 5
		}
		const allLinesLength = this.$wrapper.find( '.agency-awards_item, .agency-awards_labels' ).length
		
		this.$linesHidden = this.$wrapper.find( '.agency-awards_item, .agency-awards_labels' ).slice( maxLines - 1, allLinesLength );
		this.$lines       = this.$wrapper.find( '.agency-awards_item, .agency-awards_labels' ).slice( 0, maxLines );
		this.$parent      = this.$wrapper.closest( '.agency-awards' );
		this.$button      = this.$wrapper.find( '.agency-awards_more' );
	}
	
	
	initEl() {
		this.tw.stshow = ScrollTrigger.create( {
			trigger: this.$wrapper,
			start:   'top 80%',
			onEnter: () => this.animateFromTop()
		} );
		this.tw.sthide = ScrollTrigger.create( {
			trigger:     this.$wrapper,
			start:       'top bottom',
			onLeaveBack: () => this.hideElements()
		} );
		this.hideElements();
	}
	
	
	bindEvents() {
		this.onMoreClickHandler = this.onMoreClick.bind( this );
		this.$button.on( 'click', this.onMoreClickHandler );
	}
	
	
	unbindEvents() {
		this.$button.off( 'click', this.onMoreClickHandler );
	}
	
	
	animateFromTop() {
		gsap.fromTo( this.$lines, {
			opacity: 0,
			y:       50
		}, {
			opacity:         1,
			y:               0,
			duration:        0.6,
			stagger:         0.1,
			immediateRender: true
		} );
	}
	
	
	hideElements() {
		gsap.set( this.$lines, { opacity: 0 } );
		
		this.inertElements( true );
	}
	
	
	inertElements( inert ) {
		Array.from( this.$linesHidden ).forEach(
			line => {
				line.inert = inert;
			}
		)
	}
	
	
	onMoreClick() {
		this.inertElements( false )
	}
}
